import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import "../../styles/features/events/Party.css";

export default function Party() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const id = location.hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [location.hash]);

  const scrollToId = (id) => {
    const element = document.getElementById(
      id.replace(/^#/, "")
    );

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="evs-page">

      {/* HERO */}
      <section className="evs section">
        <span
          className="evs__dot evs__dot--amber evs__dot--t1"
          aria-hidden="true"
        />

        <span
          className="evs__dot evs__dot--rose evs__dot--t2"
          aria-hidden="true"
        />

        <div className="wrap grid two">
          <div>
            <h1 className="evs__title">
              Poznaj ludzi w swoim tempie.
              <br />
              Kameralnie, bez presji, naprawdę.
            </h1>

            <p className="evs__slead">
              Część wydarzeń jest otwarta — zapisujesz się
              od razu. Na pozostałe tworzymy dopasowane
              grupy i wysyłamy zaproszenia na podstawie
              krótkiej ankiety, którą wypełniasz na swoim
              profilu.
            </p>

            <div className="evs__cta">
              <button
                type="button"
                className="btn primary"
                onClick={() => scrollToId("#party-formats")}
              >
                Zapisz się na spotkanie
              </button>

              <button
                type="button"
                className="btn description"
                onClick={() => scrollToId("#workshops-how")}
              >
                Jak to wygląda?
              </button>
            </div>

            <div className="evs__facts grid two">
              <Fact
                dot="var(--orange)"
                title="Dobór wiekowy"
                text="Spotykasz osoby na podobnym etapie życia."
              />

              <Fact
                dot="var(--orange)"
                title="Wydarzenia na zaproszenie"
                text="Jakość ponad ilość."
              />

              <Fact
                dot="var(--orange)"
                title="Temat przewodni"
                text="Wspólna zajawka ułatwia pierwszy krok."
              />

              <Fact
                dot="var(--orange)"
                title="Swobodna atmosfera"
                text="Autentyczne rozmowy, zero presji, dużo uśmiechu."
              />
            </div>
          </div>

          <div>
            <img
              className="evs__hero-img evs__hero-img--party"
              src="/images/sunset-party.avif"
              alt="Spotkanie soMeet"
            />

            <span
              className="evs__media-tab"
              aria-hidden="true"
            />
          </div>
        </div>
      </section>

      {/* JAK TO DZIAŁA */}
      <section
        id="workshops-how"
        className="section wrap"
      >
        <span className="collage-dot" />

        <h2>Jak to działa?</h2>

        <div className="steps-wrap">
    <ol className="steps-party teps--orange">

      <li>
        <div className="step-content">
          <strong className="step-party-title">
            Wybierasz, jak chcesz do nas dołączyć.
          </strong>

          <span className="step-party-desc">
            Możesz zapisać się na listę zainteresowanych konkretnym typem spotkania 
            albo wypełnić naszą ankietę, żebyśmy mogli lepiej Cię poznać. 
            W obu przypadkach damy Ci znać, gdy pojawi się coś odpowiedniego dla Ciebie.
          </span>
        </div>
      </li>

      <li>
        <div className="step-content">
          <strong className="step-party-title">
            Pomagasz nam znaleźć odpowiednią grupę.
          </strong>

          <span className="step-party-desc">
            Przy zapisie na listę wybierasz rodzaj spotkania
            i miasto. Jeśli wypełnisz pełną ankietę, możemy
            dodatkowo dopasować zaproszenia do Twoich
            preferencji, zainteresowań i stylu życia.
          </span>
        </div>
      </li>

      <li>
        <div className="step-content">
          <strong className="step-party-title">
            Dostajesz zaproszenie.
          </strong>

          <span className="step-party-desc">
            Gdy zbierzemy odpowiednią grupę, odezwiemy się
            do Ciebie z propozycją terminu, miejsca
            i szczegółami spotkania.
          </span>
        </div>
      </li>

      <li>
        <div className="step-content">
          <strong className="step-party-title">
            Decydujesz, czy dołączasz.
          </strong>

          <span className="step-party-desc">
            Potwierdzasz udział i spotykamy się offline —
            przy kolacji, winie albo podczas większego
            Someet Social.
          </span>
        </div>
      </li>

    </ol>

          <div
            className="steps-collage"
            aria-hidden="true"
          >
            <img
              className="ph a"
              src="/imagesEvents/party5.jpg"
              alt=""
            />

            <img
              className="ph b"
              src="/images/party3.jpg"
              alt=""
            />

            <img
              className="ph c"
              src="/images/party4.jpg"
              alt=""
            />

            <img
              className="ph d"
              src="/images/party6.jpg"
              alt=""
            />
          </div>
        </div>
      </section>

      {/* RODZAJE SPOTKAŃ */}
      <section
        id="party-formats"
        className="section wrap"
      >
        <div className="section-head">
          <h2>Na jakie spotkanie masz ochotę?</h2>

          <p className="lead2">
            Wybierz format i miasto. Gdy zbierzemy odpowiednią grupę,
            odezwiemy się do Ciebie z propozycją terminu, miejsca
            i wszystkimi szczegółami.
          </p>
        </div>

<div className="party-format-grid">

  {/* KOLACJE */}
  <button
    type="button"
    className="party-format-card"
    onClick={() =>
      navigate("/events/party/dinner")
    }
  >
    <img
      src="/imagesEvents/dinner1.jpg"
      alt="Kolacja w kameralnym gronie"
      className="party-format-card__image"
    />

    <span className="party-format-card__body">
      <span className="party-format-card__label">
        KOLACJA
      </span>

      <strong className="party-format-card__title">
        Kolacja w kameralnym gronie
      </strong>

      <span className="party-format-card__description">
        Poznaj nowych ludzi przy wspólnej kolacji
        w małym gronie. Bez presji, w swobodnej
        atmosferze i przy dobrym jedzeniu.
      </span>

      <span className="party-format-card__link">
        Wybierz miasto →
      </span>
    </span>
  </button>


  {/* WINO */}
  <button
    type="button"
    className="party-format-card"
    onClick={() =>
      navigate("/events/party/wine")
    }
  >
    <img
      src="/images/party4.jpg"
      alt="Spotkanie przy winie"
      className="party-format-card__image"
    />

    <span className="party-format-card__body">
      <span className="party-format-card__label">
        WINE MEET
      </span>

      <strong className="party-format-card__title">
        Spotkanie przy winie
      </strong>

      <span className="party-format-card__description">
        Luźny wieczór przy winie i rozmowach.
        Wpadnij poznać nowych ludzi i spędzić
        czas trochę inaczej niż zwykle.
      </span>

      <span className="party-format-card__link">
        Wybierz miasto →
      </span>
    </span>
  </button>


  {/* SOMEET SOCIAL */}
  <button
    type="button"
    className="party-format-card"
    onClick={() =>
      navigate("/events/party/social")
    }
  >
    <img
      src="/images/party2.jpg"
      alt="Someet Social"
      className="party-format-card__image"
    />

    <span className="party-format-card__body">
      <span className="party-format-card__label">
        SOMEET SOCIAL
      </span>

      <strong className="party-format-card__title">
        Someet Social
      </strong>

      <span className="party-format-card__description">
        Większe spotkanie z muzyką, luźną atmosferą
        i większą liczbą osób. Dla tych, którzy wolą
        bardziej swobodną formę poznawania ludzi.
      </span>

      <span className="party-format-card__link">
        Wybierz miasto →
      </span>
    </span>
  </button>

</div>
      </section>
    </div>
  );
}

function Fact({
  badgeClass = "badge",
  dot,
  title,
  text,
}) {
  return (
    <div className="evs__fact">
      <span className={badgeClass}>
        <span
          className="b"
          style={
            dot
              ? { background: dot }
              : undefined
          }
        />{" "}
        {title}
      </span>

      <br />

      <span className="muted">
        {text}
      </span>
    </div>
  );
}